import { GROUP } from '../EnumTypes/ActionEnumTypes';
import { Connector } from 'Modules/UserModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import { toast } from 'react-toastify';
import { ROUTES } from 'shared/consts';
import { history } from 'Store/Reducers/RootReducer';

const init = () => ({
  type: GROUP.ADD_GROUP_INIT,
});

const success = () => ({
  type: GROUP.ADD_GROUP_SUCCESS,
});

const failure = () => ({
  type: GROUP.ADD_GROUP_FAILURE,
});

const addExternalUser = (userdata) => async (dispatch) => {
  dispatch(init());
  try {
    dispatch(ViewManagementModule.Actions.showLoader());
    await Connector.addExternalUser(userdata);
    dispatch(success());
    toast.success('Pomyślnie dodano UZ');
    dispatch(ViewManagementModule.Actions.hideLoader());
    history.push(ROUTES.EXTERNAL_USER_PAGE);
  } catch (err) {
    dispatch(ViewManagementModule.Actions.hideLoader());
    toast.error('Nie udało się dodać UZ');
    dispatch(failure());
  }
};

export default addExternalUser;
